import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GetItemSummaryApi } from "../../ApiRequests";

export const fetchItemStat = createAsyncThunk(
  "fetch/ItemStatDetails",
  async (item_id) => {
    try {
      const response = await GetItemSummaryApi(item_id);
      return response.data.data.payload;
    } catch (error) {
      console.log(error);
    }
    return [];
  }
);

const ItemStatsSlice = createSlice({
  name: "article-stats",
  initialState: {
    loading: true,
    data: {},
    isError: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchItemStat.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(fetchItemStat.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.isError = false;
    });
    builder.addCase(fetchItemStat.rejected, (state, action) => {
      console.log("Error", action);
      // console.log("Error", action.payload);
      state.loading = false;
      state.isError = true;
    });
  },
});

export default ItemStatsSlice.reducer;
